import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  heroChip: {
    marginInlineEnd: 0,
    fontSize: token.fontSizeSM - 1,
    border: 'none'
  }
}))
